<section class="graphic_container" id="graphic_container_id">
  <div class="inner_container">
    <div class="wrapper">
      <div class="inner nr1">
        <img
          class="mockup"
          [alt]="'PAGES.LANDING.USP_HERO_WOMAN_ALT' | translate"
          width="630"
          height="630"
          [src]="womanWithPhone"
          loading="lazy"
        />
      </div>

      <div class="inner nr2">
        <h2 class="title">{{ 'PAGES.LANDING.USP_MAIN_TITLE' | translate }}</h2>
        <div>
          @if (!isPinployeeVerticalPage) {
          <div class="usp_wrapper flex gap-5 py-6">
            <div
              class="usp_icon flex items-center justify-center w-[64px] h-[64px] min-w-[64px] rounded-full bg-[var(--blue_3)]"
            >
              <ui-icon name="credit-card" variant="stroke" />
            </div>
            <div class="head_wrapper flex flex-col flex-1 max-w-[450px]">
              <h3 class="usp_head text-[22px] font-bold mb-2.5">
                {{ 'PAGES.LANDING.USP_1_TITLE' | translate }}
              </h3>
              <p>{{ 'PAGES.LANDING.USP_1_DESC' | translate }}</p>
            </div>
          </div>
          } @if (isPinployeeVerticalPage) {
          <div class="usp_wrapper flex gap-5 py-6">
            <div
              class="usp_icon flex items-center justify-center w-[64px] h-[64px] min-w-[64px] rounded-full bg-[var(--blue_3)]"
            >
              <ui-icon name="calendar-01" variant="stroke" />
            </div>
            <div class="head_wrapper flex flex-col flex-1 max-w-[450px]">
              <h3 class="usp_head text-[22px] font-bold mb-2.5">
                {{ 'GENERAL.WHY_FLEX' | translate }}
              </h3>
              <p>{{ 'GENERAL.WHY_DESC' | translate }}</p>
            </div>
          </div>
          } @else {
          <div class="usp_wrapper flex gap-5 py-6">
            <div
              class="usp_icon flex items-center justify-center w-[64px] h-[64px] min-w-[64px] rounded-full bg-[var(--blue_3)]"
            >
              <ui-icon name="star" variant="stroke" />
            </div>
            <div class="head_wrapper flex flex-col flex-1 max-w-[450px]">
              <h3 class="usp_head text-[22px] font-bold mb-2.5">
                {{ 'PAGES.LANDING.USP_2_TITLE' | translate }}
              </h3>
              <p>{{ 'PAGES.LANDING.USP_2_DESC' | translate }}</p>
            </div>
          </div>
          } @if (isPinployeeVerticalPage) {
          <div class="usp_wrapper flex gap-5 py-6">
            <div
              class="usp_icon flex items-center justify-center w-[64px] h-[64px] min-w-[64px] rounded-full bg-[var(--blue_3)]"
            >
              <ui-icon name="credit-card" variant="stroke" />
            </div>
            <div class="head_wrapper flex flex-col flex-1 max-w-[450px]">
              <h3 class="usp_head text-[22px] font-bold mb-2.5">
                {{ 'PAGES.LANDING.WHY_PAY_TIT' | translate }}
              </h3>
              <p>{{ 'PAGES.LANDING.WHY_PAY_DESC' | translate }}</p>
            </div>
          </div>
          } @else {
          <div class="usp_wrapper flex gap-5 py-6">
            <div
              class="usp_icon flex items-center justify-center w-[64px] h-[64px] min-w-[64px] rounded-full bg-[var(--blue_3)]"
            >
              <ui-icon name="knight-shield" variant="stroke" />
            </div>
            <div class="head_wrapper flex flex-col flex-1 max-w-[450px]">
              <h3 class="usp_head text-[22px] font-bold mb-2.5">
                {{ 'PAGES.LANDING.USP_3_TITLE' | translate }}
              </h3>
              <p>
                {{ 'PAGES.LANDING.USP_3_DESC' | translate }}
                <span
                  ><a href="skadegodtgoerelse"
                    >{{ 'PAGES.LANDING.USP_3_LINK' | translate }}</a
                  ></span
                >
              </p>
            </div>
          </div>
          } @if (isPinployeeVerticalPage) {
          <div class="usp_wrapper flex gap-5 py-6">
            <div
              class="usp_icon flex items-center justify-center w-[64px] h-[64px] min-w-[64px] rounded-full bg-[var(--blue_3)]"
            >
              <ui-icon name="smart-phone-01" variant="stroke" />
            </div>
            <div class="head_wrapper flex flex-col flex-1 max-w-[450px]">
              <h3 class="usp_head text-[22px] font-bold mb-2.5">
                {{ 'PAGES.LANDING.USP_EASY' | translate }}
              </h3>
              <p>{{ 'PAGES.LANDING.USP_JOB' | translate }}</p>
            </div>
          </div>
          }
        </div>
        <div class="button_div">
          <app-generic-button-with-arrow
            [label]="'PAGES.LANDING.TO_BUTTON' | translate"
            (click)="buttonAction()"
          ></app-generic-button-with-arrow>
        </div>
      </div>
    </div>
  </div>
</section>
